<gl-base-modal (closeModal)="close()">
  <h2 class="title">{{ 'export_csv_header' | translate }}</h2>
  <form [formGroup]="form">
    <div class="radioButtons">
      <gl-radio-button formControlName="separator" [value]="'comma'">{{
        'comma' | translate
        }}</gl-radio-button>
      <gl-radio-button formControlName="separator" [value]="'semicolon'">{{
        'semicolon' | translate
        }}</gl-radio-button>
    </div>
  </form>
  <div class="buttons">
    <button normal-outline-button type="button" (click)="exportCSV()">
      {{ 'export_csv_basic' | translate }}
    </button>
    <button normal-outline-button type="button" (click)="export()">
      {{ 'export_csv' | translate }}
    </button>
  </div>
</gl-base-modal>
